import * as React from 'react';
import Alerts from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { type AlertProps } from './types';
import Snackbar from '@mui/material/Snackbar';

export const Alert: React.FunctionComponent<AlertProps> = (
  props: AlertProps,
) => {
  const { openAlert, setOpenAlert, alertDetails } = props;

  const handleClose = (): void => {
    setOpenAlert(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%', zIndex: 4000 }}>
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleClose}
        sx={{
          zIndex: 4000,
        }}
      >
        <Alerts
          onClose={handleClose}
          severity={alertDetails.alertType}
          sx={{ width: '100%' }}
        >
          {alertDetails.alertContent}
        </Alerts>
      </Snackbar>
    </Stack>
  );
};
